$(document).ready(function(){

  var scrollToTarget = function (tgtEl, siteHeader, scrollSpeed) {

        if (scrollSpeed === undefined) { scrollSpeed = 500 };
        // is header fixed?
        hoffset = 0;
        if (siteHeader !== undefined) {
            if (siteHeader.css('position') == 'fixed') {
                hoffset = siteHeader.height();
            }
        }
        if (tgtEl.parent().css('display') !== 'none') {
            scrollToHere = tgtEl.offset().top - hoffset;
            $('html, body').animate({
                scrollTop: scrollToHere
            }, scrollSpeed);
        }
    }


    var scrollToTargetIni = function () {

        $('a.scrollToTgt[href^="#"]').on('click', function (e) {
            e.preventDefault();
            if ($(this).attr('href').length > 1) {
                if($(this).attr('href')==='#top'){
                    tgtEl=$('body');
                }else{
                    tgtEl = $($(this).attr('href'));
                }
                scrollSpeed = 500;
                siteHeader = $('header.site-header');

                scrollToTarget(tgtEl, siteHeader, scrollSpeed);
            }
        });

    }

    scrollToTargetIni();

  $('#product-filter-form li a.filter').click(function(e){
    e.preventDefault();
    var filtertype = $(this).data('filtertype');
    var value = $(this).data('filter');

    if($('#'+filtertype).val() !== value){
      $('#'+filtertype).val(value);
    }
    else{
      $('#'+filtertype).val('');
    }

    $('#product-filter-form').submit();

  });

  $('.news-panel__title').matchHeight();

  $('.post-type-archive-product a.page-numbers').click(function(e){
    e.preventDefault();

    var href = $(this).attr('href');
    var pNum = href.split('?page=').pop();

    $('#product-filter-form #page').val(pNum);
    $('#product-filter-form').submit();

  });

    $('.flexslider').flexslider( {directionNav: true});


    $('.product-search > li').click(function(){

        $('.product-search > li > svg').attr('data-icon', 'chevron-down');
        $('.filter-panel').slideUp();

        if($(this).children('.filter-panel').is(':hidden')){
            $(this).children('svg').attr('data-icon', 'chevron-up');
            $(this).children('.filter-panel').slideDown();
        }

    });

    $('.panel-toggle').click(function(){
        $('.product-info-panel').removeClass('active');
        $(this).siblings('.product-info-panel').addClass('active');

    });

    $('.close-panel').click(function(){
        $('.product-info-panel').removeClass('active');
    });

    //Calculate min height to fix footer
    $(window).on("load", function() {

        var minHeight = window.innerHeight - ($('.header-nav').outerHeight()+$('footer').outerHeight());

        if($('.page-content').height() < minHeight){
            $('.page-content').height(minHeight);
        }
    });


    $(function() {

        var $btn = $('.greedynav button');
        var $vlinks = $('.greedynav .links');
        var $hlinks = $('.greedynav .hidden-links');

        var numOfItems = 0;
        var totalSpace = 0;
        var closingTime = 1000;
        var breakWidths = [];

        // Get initial state
        $vlinks.children().outerWidth(function(i, w) {
          totalSpace += w;
          numOfItems += 1;
          breakWidths.push(totalSpace);
        });

        var availableSpace, numOfVisibleItems, requiredSpace, timer;

        function check() {

          // Get instant state
          availableSpace = $vlinks.width() - 10;
          numOfVisibleItems = $vlinks.children().length;
          requiredSpace = breakWidths[numOfVisibleItems - 1];

          // There is not enought space
          if (requiredSpace > availableSpace) {
            $vlinks.children().last().prependTo($hlinks);
            numOfVisibleItems -= 1;
            check();
            // There is more than enough space
          } else if (availableSpace > breakWidths[numOfVisibleItems]) {
            $hlinks.children().first().appendTo($vlinks);
            numOfVisibleItems += 1;
            check();
          }
          // Update the button accordingly
          $btn.attr("count", numOfItems - numOfVisibleItems);
          if (numOfVisibleItems === numOfItems) {
            $btn.addClass('hidden');
          } else $btn.removeClass('hidden');
        }

        // Window listeners
        $(window).resize(function() {
          check();
        });

        $btn.on('click', function() {
          $hlinks.toggleClass('hidden');
          clearTimeout(timer);
        });

        $hlinks.on('mouseleave', function() {
          // Mouse has left, start the timer
          timer = setTimeout(function() {
            $hlinks.addClass('hidden');
          }, closingTime);
        }).on('mouseenter', function() {
          // Mouse is back, cancel the timer
          clearTimeout(timer);
        })

        check();

      });
  $('.woocommerce').on('change', 'input.qty', function(){
    $("[name='update_cart']").trigger("click");
  });
});


//////////////////
// WEBPACK FOOTER
// ./assets/scripts/parts/front-page.js
// module id = 17
// module chunks = 0